// extracted by mini-css-extract-plugin
export default {"skillsBlock":"SkillsBlock_skillsBlock__AKjbx","skillsContainer":"SkillsBlock_skillsContainer__9oGGd","skills":"SkillsBlock_skills__BKEvS"};